export default "__VITE_ASSET__DQ5TTA_t__"